import { apiClient } from '../http/query-client';

export function trackFacebookEvent(
  eventName: string,
  customData: Record<string, any> = {},
  userData: Record<string, any> = {}
) {
  const hasFbq = typeof window !== 'undefined' && (window as any).fbq;
  const eventId = eventName.toLowerCase() + '_' + Math.random().toString(36).substring(2, 15);

  // 1. Fire Browser Event (Meta Pixel)
  if (hasFbq) {
    (window as any).fbq('track', eventName, customData, { eventID: eventId });
  }

  // 2. Fire Server Event (Conversions API via our backend proxy)
  apiClient.post('facebook/event', {
    event_name: eventName,
    event_id: eventId,
    user_data: userData,
    custom_data: customData,
    event_source_url: typeof window !== 'undefined' ? window.location.href : undefined,
  }).catch(() => {});
}
